<div class="event-dialog-wrapper">
  <div mat-dialog-content class="text-center p-1 m-0" style="margin-top: 90px">
    @if (!currentView) {
      <mat-button-toggle-group appearance="legacy" align="center" name="fontStyle" aria-label="Font Style" [(value)]="view">
        <mat-button-toggle value="todoDetails">{{ 'Global.Details' | translate }}</mat-button-toggle>
        <mat-button-toggle value="members">{{ 'Global.Members' | translate }}</mat-button-toggle>
      </mat-button-toggle-group>
    }
  </div>
  @if ((currentView && currentView == 'todoDetails') || (!currentView && view == 'todoDetails')) {
    <div mat-dialog-content class="p-1 m-0">
      <form name="createForm" [formGroup]="createForm" class="flex-grow-item event-form">
        <div class="flex-row flex-wrap responsive-flex-container">
          <div class="flex-basis-100">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>{{ 'Courses.Event.Title' | translate }}</mat-label>
              <input style="color: black" matInput name="name" formControlName="name" [placeholder]="'Courses.Event.Title' | translate" required />
            </mat-form-field>
          </div>
          <div class="flex-row flex-basis-100 responsive-flex-container">
            <mat-form-field appearance="fill" class="flex-grow-item">
              <input matInput [matDatepicker]="startDateDP" [placeholder]="'Courses.Event.StartDate' | translate" name="startDate" formControlName="start" />
              <mat-datepicker-toggle matSuffix [for]="startDateDP"></mat-datepicker-toggle>
              <mat-datepicker #startDateDP></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex-row flex-basis-100 responsive-flex-container">
            @if (selectedFreq != 'Unrepeated') {
              <mat-form-field appearance="fill" class="flex-grow-item">
                <input matInput [matDatepicker]="endDateDP" [placeholder]="'Courses.Event.EndDate' | translate" name="endDate" formControlName="end" />
                <mat-datepicker-toggle matSuffix [for]="endDateDP"></mat-datepicker-toggle>
                <mat-datepicker #endDateDP></mat-datepicker>
              </mat-form-field>
            }
          </div>
          <div class="flex-row flex-basis-100 responsive-flex-container">
            <mat-form-field appearance="fill" class="mr-1">
              <mat-select placeholder="Fréquence" [disabled]="(type == 'edit' && !event.isAdmin) || (inputData && inputData.command == 'show-todo')" [(value)]="selectedFreq">
                @for (type of freq; track type) {
                  <mat-option [value]="type.value">
                    {{ type.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-column flex-basis-100">
            <mat-form-field appearance="fill" class="">
              <textarea style="color: black" matInput formControlName="notes" [placeholder]="'Courses.Event.Notes' | translate" max-rows="4"></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  }
  @if (currentView == 'members' || view == 'members') {
    <div>
      @if ((type == 'edit' && event.isAdmin) || type == 'create') {
        <app-share-menu [data]="shareMenuData" (userList)="setUserList($event)"></app-share-menu>
      }
      @if (type == 'edit' && !event.isAdmin) {
        <mat-list>
          @if (shareMenuData.users.length > 0) {
            <mat-label>Liste des utilisateurs</mat-label>
          }
          @for (user of shareMenuData.users; track user) {
            <mat-list-item>
              <mat-card appearance="outlined">
                <mat-label>{{ user.name + ' ' }}</mat-label>
                <mat-label>({{ user.role + ',' }}</mat-label>
                <mat-label>{{ user.email || user.type }})</mat-label>
              </mat-card>
            </mat-list-item>
          }
        </mat-list>
      }
    </div>
  }
  <div mat-dialog-actions class="flex-row space-between align-items-center m-0 p-1">
    @if (!hideSaveButton && !(type == 'edit' && !event.isAdmin)) {
      <button mat-raised-button color="primary" (click)="submit()" [disabled]="!formDatesAreValid()" aria-label="SAVE">Save</button>
    }
  </div>
</div>
